import React from 'react'
import { Link } from 'react-router-dom'
import loading_picture from '../../img/user.jpg'
/* REDUX */
import { connect } from 'react-redux'
import { followUser, unfollowUser, viewFollowers } from '../../actions/follow'
import { formatDate } from '../../utility/Formatter'

const loadData = ({ author_id, viewFollowers }) => {
	viewFollowers(author_id)
}

class FollowButton extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			following: false
		}
		this.handleFollow = this.handleFollow.bind(this)
		this.handleUnfollow = this.handleUnfollow.bind(this)
		this.isFollowing = this.isFollowing.bind(this)
	}
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		this.isFollowing(nextProps.followers, nextProps.user_id)
	}
	
	isFollowing(followers, user_id) {
		if (followers.length > 0) {
			const isFollowing = followers.indexOf(user_id) > -1 ? true : false
			if (isFollowing) {
				this.setState({
					following: true
				})
			}
		}
	}
	
	handleFollow() {
		const { authenticated, onLogin, followUser, author_id } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		followUser(author_id, () => this.setState({ following: true }))
	}
	
	handleUnfollow() {
		const { unfollowUser, author_id } = this.props
		unfollowUser(author_id, () => this.setState({ following: false }))
	}
	
	render() {
		
		const { author_id, user_id, username } = this.props
		
		if (author_id !== username) {
			if (!this.state.following) {
				return <button type="button" className="btn btn-follow" onClick={ this.handleFollow } >Follow</button>
			} else {
				return <button type="button" className="btn btn-follow" onClick={ this.handleUnfollow } >Unfollow</button>
			}
		} else {
			return <Link className="btn btn-follow" to="/settings">Edit</Link>
		}
		
	}
}

const mapStateToProps = (state, ownProps) => {
	const { followersById } = state
	const followers = followersById[ownProps.author_id] || {}
	return {
		followers,
		authenticated: state.auth.authenticated,
		user_id: state.auth.user_id,
		username: state.auth.username
	}
}

export default connect(mapStateToProps, { followUser, unfollowUser, viewFollowers })(FollowButton)


// WEBPACK FOOTER //
// ./src/components/Report/FollowButton.js